import cn from "classnames";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import type {UniversalContentItem as UniversalContentItemType} from "config/types";
import type {AppUniversalContentBlockProps} from "./UniversalContentBlock.types";
import styles from "./UniversalContentBlock.module.scss";

export const AppUniversalContentBlock = (props: AppUniversalContentBlockProps) => {
  const {
	item,
	textClassName,
	paragraphsClassName,
	orderedListClassName,
	unorderedListClassName,
  } = props;

  const propsOutput = (contentItem: UniversalContentItemType) => {
	return (
  <>
    {contentItem.text && (
    <AppText size={18} className={cn(styles.text, textClassName)}>
      <div dangerouslySetInnerHTML={{__html: contentItem.text}}></div>
    </AppText>
        )}
    {contentItem.paragraphs?.length && contentItem.paragraphs.map((paragraph, idx) => (
      <AppText size={18} className={cn(styles.paragraph, paragraphsClassName)} key={"paragraph" + idx}>
        <div dangerouslySetInnerHTML={{__html: paragraph}}></div>
      </AppText>
		))}
    {contentItem.listLabel && (
      <AppText size={18} className={styles.listLabel}>
        <div dangerouslySetInnerHTML={{__html: contentItem.listLabel}}></div>
      </AppText>
	)}
    {contentItem.orderedList?.length && (
    <ol className={cn(styles.list, orderedListClassName)}>
      {contentItem.orderedList.map((listItem, idx) => (
        <li className={styles.listItem} key={"listItem" + idx}>
          <AppText size={18}>
            <div dangerouslySetInnerHTML={{__html: listItem}}></div>
          </AppText>
        </li>
            ))}
    </ol>
        )}
    {contentItem.unorderedList?.length && (
    <ul className={cn(styles.list, unorderedListClassName)}>
      {contentItem.unorderedList.map((listItem, idx) => (
        <li className={styles.listItem} key={"listItem" + idx}>
          <AppText size={18}>
            <div dangerouslySetInnerHTML={{__html: listItem}}></div>
          </AppText>
        </li>
            ))}
    </ul>
        )}
  </>
    );
  };

  return (
    <AppFlex>
      {!item?.children?.length && propsOutput(item)}
      {item.children?.length && item.children.map((child, idx) => (
        <AppFlex key={"prop" + idx}>
          {propsOutput(child)}
        </AppFlex>
      ))}
    </AppFlex>
  );
};
